// extracted by mini-css-extract-plugin
export default {"recos":"Y3-z","productCardOverride":"Z3-z","rowHasBadge":"_3-z"};